export enum CustomerActions {
  Reset = "reset",
  FetchCustomer = "fetchCustomer",
  UpdateCustomer = "updateCustomer",
  SetSignupCompleted = "setSignupCompleted",
}
